export enum CommunicationType {
    Email = 'Email',
    Comment = 'Comment',
    Post = 'Post',
    Meeting = 'Meeting',
    Call = 'Call',
    Talk = 'Talk',
    Message = 'Message',
}
